/**
 * Reorder variation price to appear after add to cart button
 */
(function($) {
  'use strict';

  function movePrice($context) {
    const $wraps = ($context && $context.length) ? $context : $('.single_variation_wrap');

    $wraps.each(function() {
      const $wrap = $(this);
      const $variation = $wrap.find('.woocommerce-variation.single_variation').first();
      const $price = $variation.find('.woocommerce-variation-price, .price').first();
      const $target = $wrap.find('.woocommerce-variation-add-to-cart, .variations_button').first();
      const $button = $wrap.find('.single_add_to_cart_button').first();

      if (! $price.length || ! $target.length) {
        return;
      }

      $target.find('.woocommerce-variation-price').remove();

      if ($button.length) {
        $price.insertBefore($button);
        return;
      }

      $price.appendTo($target);
    });
  }

  function scheduleMove($context) {
    window.requestAnimationFrame(() => movePrice($context));
  }

  $(document).ready(function() {
    movePrice();
  });

  $(document.body).on(
    'wc_variation_form found_variation show_variation woocommerce_update_variation_values',
    '.variations_form',
    function() {
      const $wrap = $(this).find('.single_variation_wrap');

      if ($wrap.length) {
        scheduleMove($wrap);
      }
    }
  );

})(jQuery);
